import { a as e } from "./dist-C5MhUQHh.js";
import { c as t, f as n, t as r, v as i } from "./store-VaTxVx1V.js";
import { t as a } from "./collectionIcon-Be4I1YBb.js";
import { t as o } from "./page-C_DmF7B-.js";
import { useEffect as s } from "react";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { Box as u, EmptyState as d, FlexBox as f, Text as p } from "@dixa/lib-shared-habla";
import { Link as m } from "react-router-dom";
import { ampli as h } from "lib-shared-tracking";
var g = {
	gridWrapper: "_gridWrapper_3gmyc_1",
	grid: "_grid_3gmyc_1",
	kbCollectionCard: "_kbCollectionCard_3gmyc_24"
}, _ = ({ knowledgeBases: e }) => /* @__PURE__ */ c(f, {
	width: "100%",
	justifyContent: "center",
	padding: "400",
	className: g.gridWrapper,
	children: /* @__PURE__ */ c(u, {
		className: g.grid,
		children: e.map((e) => /* @__PURE__ */ c(v, { knowledgeBase: e }, e.collection.id))
	})
});
function v({ knowledgeBase: e }) {
	return /* @__PURE__ */ c(m, {
		to: t.internalKBCollection({ collectionId: e.collection.id }),
		style: { textDecoration: "none" },
		className: g.kbCollectionCard,
		"data-testid": "kb-collection-card",
		children: /* @__PURE__ */ l(f, {
			flexDirection: "column",
			gap: "300",
			children: [/* @__PURE__ */ l(f, {
				alignItems: "center",
				gap: "300",
				children: [/* @__PURE__ */ c(a, { color: e.theme.colors.icon }), /* @__PURE__ */ c(p.Heading, { children: e.title })]
			}), /* @__PURE__ */ c(f, { children: /* @__PURE__ */ c(p.Paragraph, { children: e.description }) })]
		})
	});
}
//#endregion
//#region src/pages/home/internalKBHome.tsx
function y() {
	let { loading: t, error: a, data: u } = i({
		variables: { languageId: n.En },
		fetchPolicy: "network-only"
	});
	s(() => {
		h.knowledgeInternalKbDashboardViewed({});
	}, []);
	let { reset: d } = r;
	if (s(d, [d]), t) return /* @__PURE__ */ c(e, {});
	if (a) throw a;
	let f = u?.knowledgeBases.results;
	return /* @__PURE__ */ l(o, { children: [/* @__PURE__ */ c(o.Head, { slotLeft: /* @__PURE__ */ c(o.HeadTitle, { title: "Internal knowledge bases" }) }), /* @__PURE__ */ l(o.Body, { children: [!f && /* @__PURE__ */ c(b, {}), !!f && /* @__PURE__ */ c(_, { knowledgeBases: f })] })] });
}
var b = () => /* @__PURE__ */ c(f, {
	height: "100%",
	width: "100%",
	justifyContent: "center",
	padding: "64px 0",
	children: /* @__PURE__ */ c(d, {
		icon: "file",
		title: "No knowledge bases",
		description: "Adjust your Collection settings to make them available in the Internal Knowledge Base, or create a new Collection."
	})
}), x = y;
//#endregion
export { x as default };

//# sourceMappingURL=home-DT6xwgDw.js.map